import { Box, Button, Card, CardHeader, CircularProgress } from "@mui/material";
import { useRootStore } from "../../hooks/useRootStore";
import { IssueAttach } from "../../data/IssueAttach";
import { useEffect, useState } from "react";
import IssueAttachListDialog from "../IssueAttachListDialog";

export default function IssueAttachesWidget({ issueId }: { issueId: number }) {
    const { api } = useRootStore();
    const [attaches, setAttaches] = useState([] as IssueAttach[]);
    const [loading, setLoading] = useState(true);
    const [attachesDialogOpen, setAttachesDialogOpen] = useState(false);

    useEffect(() => {
        api.getIssueAttaches(issueId).then(attaches => {
            setAttaches(attaches);
            setLoading(false);
        });
    }, [api, issueId])

    return (
        <>
            {attachesDialogOpen ? <IssueAttachListDialog issueId={issueId} attaches={attaches} onClose={(attaches) => { setAttachesDialogOpen(false); setAttaches(attaches); } } /> : ''}
            <Card className="issue-widget attaches">
                <CardHeader title="Приложения" className="card-header"/>
                <Box>
                    {loading
                        ?
                        <Box sx={{ textAlign: 'center', p: 5 }}>
                            <CircularProgress />
                        </Box>
                        :
                        <>
                            <Box>Всего: {attaches.length} файлов</Box>
                            <Button /*size="small"*/ onClick={() => setAttachesDialogOpen(true)}>Смотреть все</Button>
                        </>
                    }
                </Box>
            </Card>
        </>
    )
}